import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { HomeLayout } from "../components/layout/HomeLayout";
import { HubEditorialGrid, type HubEditorialItem } from "../components/home/HubEditorialGrid";
import { HOME_THEME as C } from "../lib/homeTheme";
import { STARTER_SONGS } from "../lib/starterSongs";

const PLAY_ITEMS: HubEditorialItem[] = [
  ...STARTER_SONGS.map((song) => ({
    id: song.id,
    title: song.title,
    description: song.description ?? "Melodía incluida para empezar a tocar.",
    path: `/songs/${song.id}`,
    accent: "lavender" as const,
  })),
  {
    id: "library",
    title: "Mis partituras",
    description: "Sube MusicXML y practica tus piezas.",
    path: "/songs",
    accent: "mint",
  },
];

export const PlayHubPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <HomeLayout>
      <div className="mx-auto max-w-7xl px-8 py-10 pb-24">
        <button
          type="button"
          onClick={() => navigate("/home")}
          className="inline-flex items-center gap-2 text-[11px] tracking-[0.14em] uppercase transition-colors duration-300 hover:text-[#99f6e4]"
          style={{ color: C.muted }}
        >
          <ArrowLeft className="h-4 w-4" />
          Inicio
        </button>

        <header className="mt-10 mb-16 max-w-3xl text-left">
          <p
            className="text-xs tracking-widest uppercase"
            style={{ color: "rgba(153, 246, 228, 0.5)" }}
          >
            Tocar
          </p>
          <h1
            className="mt-4 font-serif font-light tracking-tight text-left text-[clamp(3rem,8vw,4.5rem)] leading-[0.95]"
            style={{ color: C.text }}
          >
            Repertorio
          </h1>
          <p className="mt-6 max-w-xl text-sm leading-relaxed text-left text-white/60">
            Practica canciones con detección en tiempo real. Incluye melodías para principiantes y tu biblioteca MusicXML.
          </p>
        </header>

        <HubEditorialGrid items={PLAY_ITEMS} columns={PLAY_ITEMS.length > 1 ? 2 : 1} />
      </div>
    </HomeLayout>
  );
};

export default PlayHubPage;
